module.exports = __webpack_public_path__ + "img/agent.4f31a4ef.png";